<template>
  <q-dialog
    v-model="dialogOpen"
    class="action-dialog"
    persistent
    transition-show="scale"
    transition-hide="scale"
  >
    <div
      class="dialog-wrapper"
      :style="{ width: dialogState.width + 'px', height: dialogState.height + 'px' }"
    >
      <div
        class="dialog-close-btn"
        :class="{ 'icon-big': iconCloseBig || dialogData.iconCloseBig }"
        :style="{ color: '#616667' + '!important' }"
      >
        <i
          v-if="iconClose || iconCloseBig || dialogData.iconClose || dialogData.iconCloseBig"
          :class="iconCloseBig || dialogData.iconCloseBig ? 'uil uil-multiply big-icon' : 'uil uil-times'"
          @click="dialogOpen = false"
        />
      </div>
      <slot name="comp">
        <component
          :is="dialogComponent"
          v-bind="{ ...dialogData, ...dialogData.attrs }"
          @ok="dialogData.okCallback"
          @cancel="dialogData.cancelCallback"
        >
          <template
            v-if="dialogTitle || dialogData.dialogTitle"
            #dialogTitle
          >
            <div
              :class="dialogData.dialogTitle.class"
              :style="dialogData.dialogTitle.style"
            >
              {{ dialogTitle || dialogData.dialogTitle.content }}
            </div>
          </template>
          <template
            v-if="dialogData.body"
            #body
          >
            <div
              :class="dialogData.body.class"
              :style="dialogData.body.style"
              v-html="dialogData.body.content"
            />
          </template>
          <template
            v-if="subTitle || dialogData.subTitle"
            #subTitle
          >
            {{ subTitle || dialogData.subTitle }}
          </template>
          <template
            v-if="btnTitle || dialogData.dialogTitle"
            #btnTitle
          >
            {{ btnTitle || dialogData.dialogTitle }}
          </template>
          <template
            v-if="dialogData.footer"
            #footer
          >
            <div
              :style="dialogData.footer.style"
              :class="dialogData.footer.class"
            >
              {{ dialogData.footer.content }}
            </div>
          </template>
        </component>
      </slot>
    </div>
  </q-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import AgentActionNotAllowedDialog from '@/components/common/dialogs/AgentActionNotAllowedDialog.vue';
import SuccessDialogV2 from '@/components/common/dialogs/SuccessDialogV2.vue';
import NewErrorDialog from '@/components/common/dialogs/ErrorDialog.vue';
import NewWarningDialog from '@/components/common/dialogs/WarningDialog.vue';
import NewSuccessDialog from '@/components/common/dialogs/SuccessDialog.vue';
import MixedDialog from '@/components/common/dialogs/MixedDialog.vue';
import LicenseDialog from '@/components/common/dialogs/LicenseDialog.vue';
import IbOkCancelDialog from '@/components/common/dialogs/OkCancelDialog.vue';
import LinkDownMessage from '@/components/common/dialogs/LinkDownMessage.vue';
import SetRegistryConfigurationDialog from '@/components/common/dialogs/SetRegistryConfigurationDialog.vue';
import GeneralIssueWithInteractionDialog from '@/components/common/dialogs/GeneralIssueWithInteractionDialog.vue';
import LicenseLockedExpiredOfflineDialog from '@/components/common/dialogs/LicenseStatesDialogs/LicenseLockedExpiredOfflineDialog.vue';
import LicenseDisabledDialog from '@/components/common/dialogs/LicenseStatesDialogs/LicenseDisabledDialog.vue';
import LicenseFailureDialog from '@/components/common/dialogs/LicenseStatesDialogs/LicenseFailureDialog.vue';
import SaveChangesConfirmationDialog from '@/components/common/dialogs/SaveChangesConfirmationDialog.vue';
import LicenseTrialFailureDialog from '@/components/common/dialogs/LicenseStatesDialogs/LicenseTrialFailureDialog.vue';
import LicenseExpiredDialog from '@/components/common/dialogs/LicenseStatesDialogs/LicenseExpiredDialog.vue';
import LicenseNotFoundNoneDialog from '@/components/common/dialogs/LicenseStatesDialogs/LicenseNotFoundNoneDialog.vue';
import LicenseOccupiedDialog from '@/components/common/dialogs/LicenseStatesDialogs/LicenseOccupiedDialog.vue';
import LicenseMarketplaceDialog from '@/components/common/dialogs/LicenseStatesDialogs/LicenseMarketplaceDialog.vue';
import BackupDialog from '@/components/common/dialogs/BackupDialog.vue';
import { dialogPresets } from '@/services/dialogPresets';
import { dialogMixins } from './dialogs/dialogMixins';

export default {
  name: 'Dialog',
  components: {
    NewWarningDialog,
    NewErrorDialog,
    NewSuccessDialog,
    MixedDialog,
    LicenseDialog,
    SuccessDialogV2,
    AgentActionNotAllowedDialog,
    IbOkCancelDialog,
    LinkDownMessage,
    SetRegistryConfigurationDialog,
    GeneralIssueWithInteractionDialog,
    LicenseLockedExpiredOfflineDialog,
    LicenseFailureDialog,
    LicenseTrialFailureDialog,
    LicenseExpiredDialog,
    LicenseDisabledDialog,
    LicenseMarketplaceDialog,
    LicenseNotFoundNoneDialog,
    LicenseOccupiedDialog,
    BackupDialog,
    SaveChangesConfirmationDialog,
  },
  mixins: [dialogPresets, dialogMixins],
  props: {
    dialogTitle: {
      default: null,
    },
    subTitle: {
      default: null,
    },
    btnTitle: {
      default: null,
    },
    iconClose: {
      default: false,
    },
    iconCloseBig: {
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      dialogState: ['main/dialogState'],
      dialogComponent: ['main/dialogComponent'],
      dialogData: ['main/dialogData'],
    }),
    dialogOpen: {
      get() {
        return this.$store.getters['main/dialogOpen'];
      },
      set(value) {
        return this.$store.commit('main/dialogState', value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-wrapper {
  background: $-system-app-white;
  position: absolute;
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  .dialog-close-btn {
    position: absolute;
    z-index: 999;
    top: 17px;
    right: 20px;
    transition: 0.2s;
    line-height: 0.925;
    &.icon-big {
      width: 32px;
      height: 32px;
    }
    &:hover {
      background: $-hovers-hover-grey;
      border-radius: 50px;
    }
    .big-icon {
      width: 32px;
      height: 32px;
      padding: 4px;
      color: $-text-text-medium;
      line-height: 30px;
    }
    i {
      cursor: pointer;
      font-size: 24px;
    }
  }
}
:deep(.action-dialog) {
  //width: 400px;
  //height: 500px;
  background: $-system-app-white;
}
</style>
